import { Any, JsonObject, JsonProperty } from 'json2typescript';
import { isNilty } from '@core/utils.service';
import { BaseObject } from './base-object-model';
import { PaginationAndSorting } from './pagination-and-sorting-model';
import { DateConverter, fromDateToFiltersString } from './date-converter';
import { MatChipsData } from './mat-chips-data-model';

@JsonObject('Operation')
export class Operation extends BaseObject {
  @JsonProperty('id', String, true) id: string = undefined;
  @JsonProperty('documentNumber', String, true) documentNumber: string = undefined;
  @JsonProperty('type', String, true) type: string = undefined;
  @JsonProperty('status', String, true) status: string = undefined;
  @JsonProperty('logisticPartner', String, true) logisticPartner: string = undefined;
  @JsonProperty('orderType', String, true) orderType: string = undefined;
  @JsonProperty('client', String, true) client: string = undefined;
  @JsonProperty('data', Any, true) data: any = undefined;
  @JsonProperty('operationFeed', Any, true) operationFeed: any = undefined;
  @JsonProperty('confirmationFeed', Any, true) confirmationFeed: any = undefined;
  @JsonProperty('consignmentExpirationDate', DateConverter, true) consignmentExpirationDate: Date = undefined;
}

@JsonObject('OperationFilters')
export class OperationFilters extends PaginationAndSorting {
  @JsonProperty('operationType', String, true) operationType: string = undefined;
  @JsonProperty('orderType', String, true) orderType: string = undefined;
  @JsonProperty('logisticPartner', String, true) logisticPartner: string = undefined;
  @JsonProperty('client', String, true) client: string = undefined;
  @JsonProperty('status', String, true) status: string = undefined;
  @JsonProperty('supplierCode', String, true) supplierCode: string = undefined;
  @JsonProperty('customerOrderReference', String, true) customerOrderReference: string = undefined;
  @JsonProperty('feedId', String, true) feedId: string = undefined;
  @JsonProperty('documentNumber', String, true) documentNumber: string = undefined;
  @JsonProperty('operationId', String, true) operationId: string = undefined;
  @JsonProperty('operationIds', [String], true) operationIds: string[] = undefined;
  @JsonProperty('warehouse', String, true) warehouse: string = undefined;
  @JsonProperty('carrier', String, true) carrier: string = undefined;
  @JsonProperty('sku', String, true) sku: string = undefined;
  @JsonProperty('latestShipDateFrom', DateConverter, true) latestShipDateFrom: Date = undefined;
  @JsonProperty('latestShipDateTo', DateConverter, true) latestShipDateTo: Date = undefined;
  @JsonProperty('partnerStatus', String, true) partnerStatus: string = undefined;
}

export const operationFiltersMap = (
  operationType?: string,
  documentNumber?: string,
  logisticPartner?: string,
  client?: string,
  status?: string,
  orderType?: string,
  supplierCode?: string,
  customerOrderReference?: string,
  operationIds?: string[],
  warehouse?: string,
  carrier?: string,
  latestShipDateFrom?: Date,
  latestShipDateTo?: Date,
  partnerStatus?: string,
  sku?: string,
): MatChipsData[] => {
  const map: MatChipsData[] = [];
  if (!isNilty(operationType)) {
    map.push(new MatChipsData('Type', operationType));
  }
  if (!isNilty(documentNumber)) {
    map.push(new MatChipsData('Document Number', documentNumber));
  }
  if (!isNilty(logisticPartner)) {
    map.push(new MatChipsData('Logistic Partner', logisticPartner));
  }
  if (!isNilty(client)) {
    map.push(new MatChipsData('Client', client));
  }
  if (!isNilty(status)) {
    map.push(new MatChipsData('Status', status));
  }
  if (!isNilty(orderType)) {
    map.push(new MatChipsData('Order Type', orderType));
  }
  if (!isNilty(supplierCode)) {
    map.push(new MatChipsData('Supplier', supplierCode));
  }
  if (!isNilty(customerOrderReference)) {
    map.push(new MatChipsData('Customer Order', customerOrderReference));
  }
  if (operationIds?.length > 0) {
    map.push(new MatChipsData('Operation IDs', operationIds.join(', ')));
  }
  if (!isNilty(warehouse)) {
    map.push(new MatChipsData('Warehouse', warehouse));
  }
  if (!isNilty(carrier)) {
    map.push(new MatChipsData('Carrier', carrier));
  }
  if (latestShipDateFrom ?? false) {
    map.push(new MatChipsData('Latest Ship Date From', fromDateToFiltersString(latestShipDateFrom)));
  }
  if (latestShipDateTo ?? false) {
    map.push(new MatChipsData('Latest Ship Date To', fromDateToFiltersString(latestShipDateTo)));
  }
  if (!isNilty(partnerStatus)) {
    map.push(new MatChipsData('Partner Status', partnerStatus));
  }
  if (!isNilty(sku)) {
    map.push(new MatChipsData('Sku', sku));
  }
  return map;
};
